<template>
    <v-dialog v-model="dialog" max-width="1000" transition="dialog-bottom-transition">
        <v-card>
            <v-card-title class="text-white green darken-1">
                交付模型关联管理
            </v-card-title>

            <v-card-text>
                <v-row class="mt-3">
                    <!-- 左侧已选列表 -->
                    <v-col cols="3">
                        <v-card outlined>
                            <v-card-title class="subtitle-1">已选模型({{ selectedModels.length }})</v-card-title>
                            <v-divider></v-divider>
                            <v-list dense style="max-height: 400px; overflow-y: auto;">
                                <v-list-item v-for="(item, i) in selectedModels" :key="i">
                                    <v-list-item-content>
                                        <v-list-item-title>{{ item.name }}</v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <v-btn icon small @click="removeModel(item)">
                                            <v-icon small color="error">mdi-close</v-icon>
                                        </v-btn>
                                    </v-list-item-action>
                                </v-list-item>
                                <v-list-item v-if="!selectedModels.length"
                                    class="text-center text-subtitle-2 grey--text">
                                    暂无已选模型
                                </v-list-item>
                            </v-list>
                        </v-card>
                    </v-col>

                    <!-- 右侧模型列表 -->
                    <v-col cols="9">
                        <v-row>
                            <v-col cols="12">
                                <v-card outlined hover v-if="!displayModels || displayModels.length === 0">
                                    <v-card-title class="subtitle-1">暂无模型</v-card-title>
                                </v-card>
                                <v-card outlined hover v-else class="pb-2">
                                    <v-card-title class="subtitle-1">
                                        <span>模型列表</span>
                                        <v-spacer></v-spacer>
                                        <v-btn small color="primary" @click="handleQuery">
                                           搜索
                                        </v-btn>
                                    </v-card-title>
                                    <div class="px-3 mt-2">
                                        <v-text-field dense v-model="keyword" label="模型名称关键词" hide-details @keyup.enter="handleQuery"></v-text-field>
                                    </div>
                                </v-card>
                            </v-col>
                    
                            <v-col v-for="(model, i) in displayModels" :key="i" cols="12" sm="6" md="3">
                                <v-card 
                                    outlined 
                                    hover
                                    class="model-card"
                                    :class="{'selected-card': isSelected(model)}"
                                    @click="isSelected(model) ? removeModel(model) : selectModel(model)"
                                >
                                    <v-img 
                                        :src="model.cover" 
                                        height="120"
                                        cover
                                        class="model-image"
                                    >
                                        <template v-slot:placeholder>
                                            <v-row class="fill-height ma-0" align="center" justify="center">
                                                <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                                            </v-row>
                                        </template>
                                        <div class="model-overlay d-flex align-center justify-center">
                                            <v-icon 
                                                size="36" 
                                                :color="isSelected(model) ? 'error' : 'primary'"
                                            >
                                                {{ isSelected(model) ? 'mdi-close-circle' : 'mdi-plus-circle' }}
                                            </v-icon>
                                        </div>
                                    </v-img>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <div
                                                class="subtitle-2 text-center pa-2 text-cut"
                                                v-bind="attrs"
                                                v-on="on"
                                            >
                                                {{ model.name }}
                                            </div>
                                        </template>
                                        <span>{{ model.name }}</span>
                                    </v-tooltip>
                                </v-card>
                            </v-col>
                        </v-row>

                        <!-- 分页 -->
                        <div class="text-center pt-3">
                            <v-pagination 
                                v-model="pageNo" 
                                :length="Math.ceil(total / pageSize)"
                                :total-visible="7"
                                @input="handleQuery"
                            ></v-pagination>
                        </div>
                    </v-col>
                </v-row>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="dialog = false">
                    关闭
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

</template>

<script>
import { bindCourseModelResource, unbindCourseModelResource } from '@/api/model_resource';
export default {
    props: {
        /**
         * 是否显示对话框
         */
        dialogModel: {
            type: Boolean,
            default: false,
        },
        /**
         * 关系ID
         */
        relationId: {
            type: String,
            default: '',
        },
        /**
         * 查询函数
         */
        queryModelFunction: {
            type: Function,
            default: () => {},
        },
        /**
         * 查询课程模型函数
         */
        queryCourseModelFunction: {
            type: Function,
            default: () => {},
        },
    },
    data() {
        return {
            displayModels: [],
            total: 0,
            pageNo: 1,
            pageSize: 8,
            selectedModels: [],
            keyword: '',
        }
    },
    computed: {
        dialog: {
            get() {
                return this.dialogModel;
            },
            set(value) {
                this.$emit('update:dialogModel', value);
            }
        },
    },
    watch: {
        dialog(val) {
            if (val) {
                this.handleQuery();
                this.handleQueryCourseModel();
            }
        }
    },
    methods: {
        /**
         * 选择模型
         */
        selectModel(model) {
            this.selectedModels.push(model);
            bindCourseModelResource({
                relationId: this.relationId,
                modelId: model.id,
            })
        },
        /**
         * 移除模型
         */
        removeModel(model) {
            this.selectedModels = this.selectedModels.filter(item => item._id !== model._id);
            unbindCourseModelResource({
                relationId: this.relationId,
                modelId: model.id,
            })
        },
        /**
         * 查询模型
         */
        handleQuery() {
            this.queryModelFunction({
                pageNo: this.pageNo,
                pageSize: this.pageSize,
                keyword: this.keyword,
            }).then(res => {
                this.displayModels = res.data.rows;
                this.total = res.data.total;
            });
        },
        handleQueryCourseModel() {
            this.queryCourseModelFunction({
                relationId: this.relationId,
            }).then(res => {
                this.selectedModels = res.data;
            });
        },
        isSelected(model) {
            return this.selectedModels.some(item => item._id === model._id);
        }
    }
}
</script>

<style scoped>
.model-card {
    transition: all 0.3s ease;
    height: 160px;
    position: relative;
    overflow: hidden;
    cursor: pointer;
}

.model-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    opacity: 0;
    transition: opacity 0.2s ease;
    height: 120px;
}

.model-card:hover .model-overlay {
    opacity: 1;
}

.selected-card .model-overlay {
    opacity: 1;
    background: rgba(33, 150, 243, 0.3);
}

.model-image {
    height: 120px !important;
}

.text-truncate {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
}

.text-cut {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>
